import { connect } from 'react-redux';
import { IState } from '../../store/index';

import { IOfferSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { getOfferType, isCommercial } from '../../utils/offer_type';
import { BtiDistrict, IBtiDistrictProps } from './index';

function roomsCount(offer: IOfferSchema) {
  const isCommercialCard = isCommercial(getOfferType(offer));

  return isCommercialCard ? 1 : (offer.roomsCount || null);
}

function mapStateToProps(state: IState): IBtiDistrictProps {
  return {
    districtData: state.offerData.bti && state.offerData.bti.districtData || null,
    offer: state.offerData.offer,
    roomsCount: roomsCount(state.offerData.offer),
  };
}

// tslint:disable-next-line:no-any
export const BtiDistrictContainer = connect<IBtiDistrictProps, any, any>(mapStateToProps)(BtiDistrict);
